import { z } from "zod";
import { MediaSchema } from "./media";

export const PRICE_TYPE = {
    FIXED: 'fixed',
    MONTHLY: 'monthly',
} as const;

export type PriceType = typeof PRICE_TYPE[keyof typeof PRICE_TYPE];

export const PriceTypeSchema = z.enum(['fixed', 'monthly']);

export const PackagedServiceSchema = z.object({
    id: z.number(),
    service_name: z.string().nullable().optional(),
    slug: z.string().nullable().optional(),
    starting_price: z.number().nullable().optional(),
    price_type: PriceTypeSchema.nullable().optional().default('fixed'),
    /** @deprecated Use media instead */
    thumbnail: z.string().nullable().optional(),
    /** @deprecated Use gallery_media instead */
    gallery_images: z.array(z.string()).nullable().optional().default([]),
    featured_media: MediaSchema.nullable().optional(),
    gallery_media: z.array(MediaSchema).nullable().optional(),
    description: z.string().nullable().optional(),
});
